import { useViewActions, VIEWS_ACTIONS } from 'reducers/viewsSlice';

import { CloneView } from './CloneView/CloneView';
import { EditView } from './EditView/EditView';
import { ManageViews } from './ManageViews/ManageViews';
import { Views } from './Views';

export const ViewsWrapper = () => {
  const viewAction = useViewActions();

  let screen;
  switch (viewAction) {
    case VIEWS_ACTIONS.CREATE:
      screen = <Views />;
      break;
    case VIEWS_ACTIONS.EDIT_CUSTOM_ACCESS:
      screen = <Views />;
      break;
    case VIEWS_ACTIONS.EDIT:
      screen = <EditView />;
      break;
    case VIEWS_ACTIONS.CLONE:
      screen = <CloneView />;
      break;
    default:
      screen = <ManageViews />;
  }

  return screen;
};
